import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';

import routing from './yearly_group_report.routes';
import MonthlyGroupActivePowerService from '../../../components/api/monthly_group_active_power/monthly_group_active_power.service';
import Chart from '../../../components/directive/chart/chart.directive';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import CsvUtil from '../../../components/logic/csv_util/csv.util';
import MathUtil from '../../../components/logic/math_util/math_util';
import GroupReportUtil from '../../../components/logic/group_report/group_report_util.service';
import chartConfig from './yearly_group_report.config';

export class YearlyGroupReportController {
  /*@ngInject*/
  constructor($state, $stateParams, $filter, moment, DateUtil, MonthlyGroupActivePowerService, CsvUtil, GroupReportUtil, MathUtil) {
    this.id = $stateParams.id;
    this.$filter = $filter;
    this.$state = $state;
    this.MonthlyGroupActivePowerService = MonthlyGroupActivePowerService;
    this.moment = moment;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;
    this.MathUtil = MathUtil;
    this.GroupReportUtil = GroupReportUtil;

    this.downloadFileName = 'active_power.csv';

    this.chartConfig = chartConfig(this);
  }

  $onInit() {
    this.MonthlyGroupActivePowerService.show(
      {id: this.id},
      response => {
        let powers = response.powers;
        let lastDate = powers.length > 0 ?
          this.moment(powers[powers.length - 1].date).subtract(1, 'days')
          : this.moment();
        lastDate.startOf('month');

        // UI 表示用
        this.startDate = lastDate.clone().subtract(12, 'month');
        this.endDate = lastDate.clone();

        this.categories = [];
        let start = lastDate.clone().add(lastDate.utcOffset(), 'minutes').utc().subtract(12, 'month');

        for (let i = 0; i < 13; i++) {
          this.categories.push(start.valueOf());
          start.add(1, 'month');
        }

        this.chartConfig.xAxis.categories = this.categories;
        this.chartConfig.xAxis.max = 12;

        [this.seriesList, this.sumSeriesList] = this.formatGroupActivePower(powers);

        if (this.isOverStackLimit) {
          this.chartConfig.series = this.sumSeriesList;
        } else {
          this.chartConfig.series = this.seriesList;
        }

        //add click event
        for (let series of this.chartConfig.series) {
          series.events = {
            click: event => {
              this.$state.go(
                'main.group_report_show.detail',
                {id: this.id, term: 'monthly', target: event.point.date},
                {reload: true}
              )
            }
          };
          series.cursor = 'pointer';
        }

        this.sumSeries = this.sumSeriesList[0];
        this.csvData = this.CsvUtil.processDailyGroupActivePower(this.seriesList, this.categories);
        this.downloadFileName = `group_active_power_${this.startDate.format('YYYY-MM')}_${this.endDate.format('YYYY-MM')}.csv`;
      }
    );
  }

  formatGroupActivePower(groupActivePowers) {
    if (groupActivePowers.length < 1) {
      return [[], []];
    }

    // 処理内容の詳細については daily_group_report_component.js を参照

    const STACK_LIMIT = 10;
    this.isOverStackLimit = false;

    let firstMeasuredAt = this.moment(groupActivePowers[0].date).subtract(1, 'days').add(this.moment().utcOffset(), 'minutes');
    let beginningDate = this.moment(this.categories[0]);
    let shiftRange = firstMeasuredAt.diff(beginningDate, 'months');

    let seriesList = this.GroupReportUtil.createSeriesList(groupActivePowers, shiftRange);

    if (seriesList.length > STACK_LIMIT) {
      this.isOverStackLimit = true;
    }

    let [stackSeriesList, sumSeriesList] = this.GroupReportUtil.createStackSeries(seriesList, groupActivePowers, shiftRange);

    return [stackSeriesList, sumSeriesList];
  }
}

export default angular.module('leptonApp.yearlyGroupReport', [uiRouter, moment, DateUtil, MonthlyGroupActivePowerService, CsvUtil, GroupReportUtil, MathUtil])
  .config(routing)
  .component('yearlyGroupReport', {
    require: {parentComponent: '^groupReportShow'},
    template: require('./yearly_group_report.html'),
    controller: YearlyGroupReportController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/group_report/yearly/yearly_group_report.component.js